import { type PipelineBoardSort, PipelineRouteKey } from '@/pages/pipelines/common/types';

import type { InvestmentPipelineUrlFilters } from './types';
import {
  compareInvestmentPipelineCards,
  compareInvestmentPipelineCardsByLastStageChanged,
} from './utils/sort';

export const INVESTMENT_PIPELINE = PipelineRouteKey.Investment;
export const INVESTMENT_PIPELINE_TITLE = 'Investment Pipeline';

export const INVESTMENT_PIPELINE_API_SORT = {
  urgencyThenLastStageChanged: 'UrgencyThenLastStageChanged',
  lastStageChanged: 'LastStageChanged',
} as const;

type InvestmentPipelineBoardSortMode = 'timerUrgencyThenLastStageChanged' | 'lastStageChanged';

export type InvestmentPipelineBoardSort = PipelineBoardSort & {
  mode: InvestmentPipelineBoardSortMode;
};

export const INVESTMENT_PIPELINE_DEFAULT_BOARD_SORT: InvestmentPipelineBoardSort = {
  mode: 'timerUrgencyThenLastStageChanged',
  active: false,
  direction: 'desc',
  compareCards: compareInvestmentPipelineCards,
};

export const getInvestmentPipelineBoardSort = (sort?: string): InvestmentPipelineBoardSort => {
  if (sort === INVESTMENT_PIPELINE_API_SORT.lastStageChanged) {
    return {
      mode: 'lastStageChanged',
      active: true,
      direction: 'desc',
      compareCards: compareInvestmentPipelineCardsByLastStageChanged,
    };
  }

  return INVESTMENT_PIPELINE_DEFAULT_BOARD_SORT;
};

export const getInvestmentPipelineApiSort = (sort: InvestmentPipelineBoardSort): string =>
  sort.mode === 'lastStageChanged'
    ? INVESTMENT_PIPELINE_API_SORT.lastStageChanged
    : INVESTMENT_PIPELINE_API_SORT.urgencyThenLastStageChanged;

export const INVESTMENT_PIPELINE_FILTER_KEYS = new Set<keyof InvestmentPipelineUrlFilters>([
  'introducerUserIds',
  'investorUserIds',
  'fundIds',
  'introductionTypes',
  'timerStatuses',
  'activeOnly',
]);
